import { Container } from '@cgs/wge';
import { SpinResponse } from '@cgs/data-access';
import {
  GAME_STATE_MACHINE_TOKEN,
  GameStateMachine,
  GameWinComponent,
  SLOT_MACHINE_STORE_TOKEN,
  SlotMachineStore,
} from '@cgs/machines';
import { TRIFECTA_SDK_ADAPTER_TOKEN, TrifectaSDKAdapter } from '../../../sdk/trifecta-sdk.adapter';
import {
  TRIFECTA_LAUNCH_PARAMS_TOKEN,
  TrifectaLaunchParamsDto,
} from '../../../models/trifecta-dto';

export class TrifectaGameWinComponent implements GameWinComponent {
  private readonly trifectaSDKAdapter: TrifectaSDKAdapter;
  private readonly launchParams: TrifectaLaunchParamsDto;
  private readonly slotMachineStore: SlotMachineStore;
  private readonly gameStateMachine: GameStateMachine<SpinResponse>;
  private readonly currencyMultiplier: number;

  constructor(container: Container) {
    this.trifectaSDKAdapter = container.resolve<TrifectaSDKAdapter>(TRIFECTA_SDK_ADAPTER_TOKEN);
    this.launchParams = container.resolve<TrifectaLaunchParamsDto>(TRIFECTA_LAUNCH_PARAMS_TOKEN);
    this.currencyMultiplier = 10 ** -this.launchParams.currencyDecimals;
    this.gameStateMachine =
      container.resolve<GameStateMachine<SpinResponse>>(GAME_STATE_MACHINE_TOKEN);
    this.slotMachineStore = container.resolve<SlotMachineStore>(SLOT_MACHINE_STORE_TOKEN);

    this.handleFreeSpinsEnd();
  }

  public addWin(amount: number): void {
    if (!this.slotMachineStore.state.freeSpinsInfo) {
      this.trifectaSDKAdapter.addWin(this.formatWin(amount));
    }
  }

  public resetWin(): void {
    //
  }

  public updateWin(_win: number): void {
    //
  }

  public synchronize(): void {
    //
  }

  protected handleFreeSpinsEnd(): void {
    this.gameStateMachine.endFreeSpinsPopup.leaved.listen(() => {
      const totalWin = this.slotMachineStore.state.freeSpinsInfo?.getFullWin() || 0;

      if (totalWin) {
        this.trifectaSDKAdapter.addWin(this.formatWin(totalWin));
      }
    });
  }

  protected formatWin(win: number): number {
    return win * this.currencyMultiplier;
  }
}
